import { Component, DestroyRef, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppState } from '@cbcore/NGRX/core.state';
import { loadLeaderboardWidget } from '@cbcore/NGRX/manager/manager.actions';
import { selectManagersState } from '@cbcore/NGRX/manager/manager.selectors';
import { Config } from "@cbcore/services/config/config.service";
import { Store } from '@ngrx/store';
import { isEqual, cloneDeep } from 'lodash-es';
import { Observable } from "rxjs";
import { ManagersState } from "@cbcore/NGRX/manager/manager.model";
import { distinctUntilChanged } from "rxjs/operators";
import { SlicePipe } from '@angular/common';
import { WidgetTopCaptainsComponent } from '../top-captains/top-captains';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';

@Component({
    selector: 'widget-multi-container',
    templateUrl: './multi-container.html',
    imports: [PipesModule, TranslocoModule, WidgetTopCaptainsComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        SlicePipe
    ]
})
export class MultiContainerComponent implements OnInit {
  @Input() sportId!: number; // Always bound by real consumers
  public sport_category: any;
  public loading!: boolean; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  public showCaptainsWidget!: boolean; // Assigned inside checkTopROI()'s if(data) branch, called unconditionally from ngOnInit's managersState$ subscribe — pre-existing assumption, not independently verified
  public clicked?: boolean; // Assigned via the template's (clicked) event binding
  public data: any;
  public showBothWidgets!: boolean; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  public dynamicWidgets!: boolean; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  public params: any = {};

  private destroyRef = inject(DestroyRef);
  private managersState$!: Observable<ManagersState>; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified

  constructor(
    private _config: Config,
    private store: Store<AppState>
  ) {
  }

  ngOnInit() {
    this.loading = true;
    this.dynamicWidgets = true;
    this.showBothWidgets = this._config.CONFIG.showBothWidgets;

    this.managersState$ = this.store.select(selectManagersState);
    this.managersState$.pipe(
      distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(managersState => {
      this.params = managersState.leaderboardWidgetParams;
      this.checkTopROI(cloneDeep(managersState.leaderboard));
    });

    this.store.dispatch(loadLeaderboardWidget({sportId: this.sportId}));
  }

  filterNegativeROI(item: any) {
    return parseInt(item.manager_rankings[0].raw_roi, 10) > 0;
  }

  checkTopROI(data?: any): void {
    setTimeout(() => {
      if (data) {
        data.items = data.items.filter(this.filterNegativeROI);
        data.total_items = data.items.length;
        this.showCaptainsWidget = data.total_items > 0 && data.items[0].manager_rankings[0].raw_roi > 0 && this.dynamicWidgets;
        this.data = data;
        this.loading = false;
      }
    }, 0);
  }
}
